export default __webpack_public_path__ + "static/media/biodata-outline-16px.707aee81.svg";